import { cloneElement, isValidElement, ReactElement, useEffect, useRef, useState } from "react"
import { Tooltip as MuiTooltip, TooltipProps } from "@mui/material"
import classNames from "classnames"

import Divider from "@/components/divider/Divider"
import "./tooltip.scss"

export default function Tooltip({
  children,
  type = "text",
  size = "medium",
  label,
  ...props
}: TooltipProps & {
  type?: "chart" | "text"
  size: "medium" | "small"
  label?: string
}) {
  const dummyElement = useRef<HTMLDivElement | null>(null)
  const [position, setPosition] = useState({ x: 0, y: 0 })

  const handleMouseMove = (event: React.MouseEvent<HTMLElement>) => {
    if (!event.currentTarget) {
      return
    }

    const parent = event.currentTarget.getBoundingClientRect() // 부모 컨테이너 기준 좌표 가져오기
    const relativeX = event.clientX - parent.left // 부모 기준 X 좌표
    const relativeY = event.clientY - parent.top // 부모 기준 Y 좌표

    setPosition((prev) =>
      prev.x === relativeX && prev.y === relativeY ? prev : { x: relativeX, y: relativeY },
    )
  }

  useEffect(() => {
    if (dummyElement.current) {
      dummyElement.current.style.transform = `translate(${position.x + 30}px, ${position.y + 30}px)`
    }
  }, [position])

  if (type === "chart") {
    return (
      <>
        <div ref={dummyElement} style={{ position: "absolute", top: 0, left: 0 }} />
        <MuiTooltip
          arrow={false}
          placement="bottom-start"
          {...props}
          title={
            <div className="TooltipContentCont">
              {label && (
                <>
                  <span className="tooltip-chart-label">{label}</span>
                  <Divider />
                </>
              )}
              {typeof props.title === "string" ? (
                <p className={classNames("tooltip-subtext", type, size)}>{props.title}</p>
              ) : (
                props.title
              )}
            </div>
          }
          // 커서 위치에 따라 툴팁이 자동으로 위치를 조정하는 기능
          slotProps={{
            popper: {
              anchorEl: dummyElement.current,
              disablePortal: true,
            },
          }}>
          {isValidElement<HTMLElement>(children)
            ? cloneElement(
                children as ReactElement<{
                  onMouseMove?: (event: React.MouseEvent<HTMLElement>) => void
                }>,
                { onMouseMove: handleMouseMove },
              )
            : children}
        </MuiTooltip>
      </>
    )
  }

  return (
    <MuiTooltip
      arrow={false}
      placement={"top"}
      {...props}
      title={
        <div className="TooltipContentCont">
          {typeof props.title === "string" ? (
            <p className={classNames("tooltip-subtext", type, size)}>{props.title}</p>
          ) : (
            props.title
          )}
        </div>
      }>
      {children}
    </MuiTooltip>
  )
}
